export var EKey;
(function (EKey) {
  EKey["text"] = "text";
  EKey["title"] = "title";
  EKey["link"] = "link";
  EKey["img"] = "img";
  EKey["video"] = "video";
  EKey["featuresList"] = "featuresList";
  EKey["data"] = "data";
  EKey["file"] = "file";
})(EKey || (EKey = {}));